import { Directive } from '@angular/core';

@Directive({
  selector: 'kros-label',
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class KrosLabel {}
